<!-- @format -->

@for (assessmentItem of assessmentItemsData; track assessmentItem; let assItemIndex = $index) {
  @for (cur of filterAssessmentItemCurs(assessmentItem); track cur) {
    <div class="cur-separator">
      <div class="row cur-enrolment-container">
        <div class="col-md-8 col-sm-12">
          <div role="heading" [attr.aria-level]="level" class="fudis-heading__lg sis-mt-sm"
            >{{ cur.name | localizedString }} {{ cur.activityPeriod | localDateRange }}</div
          >

          @for (sgs of cur.studyGroupSets; track sgs) {
            <div class="sis-my-sm">
              @if (sgsSsgIdMatchToEnrolmentSSG(sgs)) {
                <div role="heading" [attr.aria-level]="level + 1" class="fudis-heading__md sis-my-sm">
                  {{ sgs.name | localizedString }}
                </div>
              }
              @for (ssg of sgs.studySubGroups; track ssg) {
                <div>
                  @if (ssgIdMatchToEnrolmentSSG(ssg.id)) {
                    <sis-description-list>
                      <dl>
                        <ng-template #listItem>
                          <dt class="sis-label">{{ ssg.name | localizedString }}</dt>
                          <dd>
                            <app-study-event-info-list [studyEvents]="ssg.studyEvents" [teacherIds]="ssg.teacherIds" />
                          </dd>
                        </ng-template>
                      </dl>
                    </sis-description-list>
                  }
                </div>
              }
            </div>
          }
          @if (!hideEnrolmentQuestionnaire && cur.enrolmentQuestionnaire?.enrolmentQuestions?.length > 0) {
            <div>
              <div role="heading" [attr.aria-level]="level + 1" class="fudis-heading__md">{{
                "OPEN_UNIVERSITY.ENROLMENT_WIZARD.ENROLMENT_QUESTIONAIRE_TITLE" | translate
              }}</div>
              @for (
                enrolmentQuestion of cur?.enrolmentQuestionnaire?.enrolmentQuestions;
                track enrolmentQuestion;
                let enrolmentQIndex = $index
              ) {
                <div class="mb-4">
                  @if (enrolmentQuestion?.questionType === "FREE_TEXT") {
                    <sis-description-list>
                      <dl>
                        <ng-template #listItem>
                          <dt class="sis-label">{{
                            parseFreetextQuestionTitle(enrolmentQIndex + 1, enrolmentQuestion?.question | localizedString)
                          }}</dt>
                          <dd>{{ findEnrolmentQuestionAnswer(enrolmentQuestion.localId, "FREE_TEXT") }}</dd>
                        </ng-template>
                      </dl>
                    </sis-description-list>
                  }
                  @if (enrolmentQuestion.questionType === "LANGUAGE_SELECT") {
                    <sis-description-list>
                      <dl>
                        <ng-template #listItem>
                          <dt class="sis-label">{{ "ENROLMENT_QUESTIONAIRE_LANG_ANSWER_TITLE" | translate }}</dt>
                          <dd>{{
                            findEnrolmentQuestionAnswer(enrolmentQuestion.localId, "LANGUAGE_SELECT") | codeLocalizedName | async
                          }}</dd>
                        </ng-template>
                      </dl>
                    </sis-description-list>
                  }
                </div>
              }
            </div>
          }
        </div>

        @if (modifySelectionsTemplateRef) {
          <ng-container [ngTemplateOutlet]="modifySelectionsTemplateRef" [ngTemplateOutletContext]="{ $implicit: assItemIndex }">
          </ng-container>
        }
      </div>
    </div>
  }
}
